<template>
  <BModal
    v-model="isOpen"
    no-enforce-focus
    size="lg"
    centered
    hide-footer
    title="Edit invoice notes"
  >
    <div class="row no-gutters">
      <AppWysiwyg
        :value="invoice.notes"
        @input="updateNotes($event)"
        class="col-12"
        label="Notes"
        field="notes"
        :errors="errors"
      />
    </div>
    <div class="row mt-3">
      <div class="col-12 text-right">
        <button class="btn btn-primary" @click="save">Save</button>
      </div>
    </div>
  </BModal>
</template>

<script>
import { mapGetters } from 'vuex';
import { BModal } from 'bootstrap-vue';
import Errors from '../../utils/errors';
import AppWysiwyg from '../form/AppWysiwyg';

export default {
  data() {
    return {
      errors: new Errors(),
      notes: null,
    };
  },
  components: {
    AppWysiwyg,
    BModal,
  },
  computed: {
    isOpen: {
      get() {
        return this.$store.state.invoices.isNotesModalOpen;
      },
      set(val) {
        this.$store.commit('invoices/isNotesModalOpen', val);
      },
    },
    ...mapGetters({
      invoice: 'invoices/invoice',
    }),
  },
  methods: {
    updateNotes(notes) {
      this.notes = notes;
    },
    save() {
      if (this.notes !== null) {
        this.updateInvoiceProps({ notes: this.notes });
      }
      this.$store.commit('invoices/isNotesModalOpen', false);
      this.$store.dispatch('invoices/updateInvoice');
    },
    updateInvoiceProps(props) {
      this.$store.dispatch('invoices/updateInvoiceProps', props);
    },
  },
};
</script>
